import React, {useEffect, useState} from 'react';
import SimpleDialog from "../../../../widgets/dialogs/SimpleDialog";
import Grid from "@mui/material/Grid";
import {DialogActions} from "@mui/material";
import Button from "@mui/material/Button";
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import makeStyles from '@mui/styles/makeStyles';
import IconButton from "@mui/material/IconButton";
import {amber, blue, green, orange, purple, red} from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import {useForm} from "react-hook-form";
import {bigNoteRegisterRequired1000, valueRegister} from "../../../../../utils/RegisterUtils";
import CustomText from "../../../../widgets/inputs/CustomText";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {CustomAutoComplete} from "../../../../widgets/inputs/CustomAutoComplete";
import CustomDateTimeInput from "../../../../widgets/inputs/CustomDateTimeInput";

const internalStyle = makeStyles((theme) => ({
    customTab: {
        textTransform: "capitalize",
        [theme.breakpoints.down('lg')]: {
            fontSize: 12
        }
    },
    amberClass: {
        backgroundColor: amber[theme.palette.mode === "light" ? 100 : 700],
        borderRadius: 24,
    },
    orangeClass: {
        backgroundColor: orange[theme.palette.mode === "light" ? 100 : 700],
        borderRadius: 24,
    },
    blueClass: {
        backgroundColor: blue[theme.palette.mode === "light" ? 100 : 700],
        borderRadius: 24,
    },
    purpleClass: {
        backgroundColor: purple[theme.palette.mode === "light" ? 100 : 700],
        borderRadius: 24,
    },
    redClass: {
        backgroundColor: red[theme.palette.mode === "light" ? 100 : 700],
        borderRadius: 24,
    },
    greenClass: {
        backgroundColor: green[theme.palette.mode === "light" ? 100 : 700],
        borderRadius: 24,
    },
}));

export const CreaEventoDialog = ({open, setOpen, evento}) => {
    const classes = innerStyle();
    const internalClasses = internalStyle();
    const [color, setColor] = useState(0);
    const {control, errors, register, reset, handleSubmit} = useForm({mode: "onChange"});

    const onSubmit = ((data) => {
        console.log(color, data)
    })

    useEffect(() => {
        reset(evento);
        if (evento.color) {
            setColor(evento.color);
        }
    }, [evento, reset])

    return (
        <React.Fragment>
            <SimpleDialog
                open={open}
                handleClose={() => setOpen(false)}
                title={<b>Crea un evento</b>}
                paperCalss={
                    color === 0 ? internalClasses.amberClass :
                        color === 1 ? internalClasses.greenClass :
                            color === 2 ? internalClasses.purpleClass :
                                color === 3 ? internalClasses.orangeClass :
                                    color === 4 ? internalClasses.redClass :
                                        internalClasses.blueClass
                }
                content={
                    <form onSubmit={handleSubmit(onSubmit)} id={"crea-evento-form"}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <CustomText
                                    variant={"filled"}
                                    control={control}
                                    rules={valueRegister}
                                    name={"evento"}
                                    label={"Titolo"}
                                    autoFocus={false}
                                    error={errors["evento"]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CustomMultiText
                                    inputRef={register(bigNoteRegisterRequired1000)}
                                    name={"note"}
                                    label={"Note"}
                                    autoFocus={false}
                                    error={errors["note"]}
                                    rows={5}
                                    variant={"filled"}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CustomDateTimeInput
                                    label={"Inizio"}
                                    error={errors}
                                    rules={{required: true}}
                                    name={"dataInizio"}
                                    control={control}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CustomDateTimeInput
                                    label={"Fine"}
                                    error={errors}
                                    rules={{required: true}}
                                    name={"dataFine"}
                                    control={control}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CustomAutoComplete
                                    control={control}
                                    label={"Partecipanti"}
                                    name={"partecipanti"}
                                    options={["Enrico Arnaudo", "Michele Luigi Greco", "Jacopo Verducci"]}
                                    multiple={true}
                                    rules={{required: true}}
                                    error={errors["partecipanti"]}
                                    variant={"filled"}
                                />
                            </Grid>
                            <Grid item xs={12} style={{paddingBottom: 0}}>
                                <Typography>
                                    Seleziona un colore per l'evento cliccandoci sopra
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <IconButton onClick={() => setColor(0)} size={"small"}
                                            style={{
                                                backgroundColor: amber[600],
                                                height: (color === 0 ? 40 : 30),
                                                width: (color === 0 ? 40 : 30),
                                                marginRight: 6
                                            }}/>
                                <IconButton onClick={() => setColor(1)} size={"small"}
                                            style={{
                                                backgroundColor: green[600],
                                                height: (color === 1 ? 40 : 30),
                                                width: (color === 1 ? 40 : 30),
                                                marginRight: 6
                                            }}/>
                                <IconButton onClick={() => setColor(2)} size={"small"}
                                            style={{
                                                backgroundColor: purple[600],
                                                height: (color === 2 ? 40 : 30),
                                                width: (color === 2 ? 40 : 30),
                                                marginRight: 6
                                            }}/>
                                <IconButton onClick={() => setColor(3)} size={"small"}
                                            style={{
                                                backgroundColor: orange[600],
                                                height: (color === 3 ? 40 : 30),
                                                width: (color === 3 ? 40 : 30),
                                                marginRight: 6
                                            }}/>
                                <IconButton onClick={() => setColor(4)} size={"small"}
                                            style={{
                                                backgroundColor: red[600],
                                                height: (color === 4 ? 40 : 30),
                                                width: (color === 4 ? 40 : 30),
                                                marginRight: 6
                                            }}/>
                                <IconButton onClick={() => setColor(5)} size={"small"}
                                            style={{
                                                backgroundColor: blue[600],
                                                height: (color === 5 ? 40 : 30),
                                                width: (color === 5 ? 40 : 30),
                                                marginRight: 6
                                            }}/>
                            </Grid>
                        </Grid>
                    </form>
                }
                actions={
                    <DialogActions>
                        <Button type={"submit"} form={"crea-evento-form"} className={classes.button}
                                style={{borderRadius: 22}}
                                variant={"contained"} disableElevation
                                onClick={handleSubmit(onSubmit)}>
                            <b>Conferma</b>
                        </Button>
                    </DialogActions>
                }
            />
        </React.Fragment>
    );
};
